import { AiAssistantService } from './aiAssistant.service';
import { AuthService } from './auth.service';
import { DonationService } from './donation.service';
import { EventCardService } from './eventCard.service';
import { FunCoinService } from './funCoin.service';
import { FunctionService } from './function';
import { FunTvService } from './funTv.service';
import { KVService } from './kv.service';
import { LessonSuggestService } from './lessonSuggest.service';
import { ListeningService } from './listening.service';
import { LoginService } from './login.service';
import { LotteryService } from './lottery.service';
import { LotteryTicketsService } from './lotteryTickets.service';
import { MemberService } from './member.service';
import { MemberRecordService } from './memberRecord.service';
import { MutipleMediaService } from './mutipleMedia.service copy';
import { NewCourseService } from './newCourse';
import { NewProductService } from './newProduct';
import { PayService } from './pay.service';
import { ReadingService } from './reading.service';
import { ReviewService } from './review.service';
import { ScheduleService } from './schedule.service';
import { SocialService } from './social.service';
import { SocialLogService } from './socialLog.service';
import { StreamingService } from './streaming.service';
import { TeacherService } from './teacher.service';
import { TelemarketQuestionnaireService } from './telemarketQuestionnare.service';
import { TestService } from './test.service';
import { TodayService } from './today.service';
import { ToeicService } from './toeic.service';
import { TutorClassService } from './tutorClass.service';
import { userReportsService } from './userReports.service';
import { VideoLibraryService } from './videoLibrary.service';

const api = {
  test: new TestService(),
  review: new ReviewService(),
  login: new LoginService(),
  kv: new KVService(),
  lessonSuggest: new LessonSuggestService(),
  videoLibrary: new VideoLibraryService(),
  teacher: new TeacherService(),
  toeic: new ToeicService(),
  telemarketQuestionnaire: new TelemarketQuestionnaireService(),
  aiAssistant: new AiAssistantService(),
  tutorClass: new TutorClassService(),
  schedule: new ScheduleService(),
  member: new MemberService(),
  userReports: new userReportsService(),
  today: new TodayService(),
  listening: new ListeningService(),
  reading: new ReadingService(),
  social: new SocialService(),
  socialLog: new SocialLogService(),
  eventCard: new EventCardService(),
  funTv: new FunTvService(),
  mutipleMedia: new MutipleMediaService(),
  memberRecord: new MemberRecordService(),
  funCoin: new FunCoinService(),
  newProduct: new NewProductService(),
  function: new FunctionService(),
  pay: new PayService(),
  donation: new DonationService(),
  newCourse: new NewCourseService(),
  lottery: new LotteryService(),
  lotteryTickets: new LotteryTicketsService(),
  auth: new AuthService(),
  streaming: new StreamingService()
};

export { api };
